module.exports = __webpack_public_path__ + "assets/media/day14.20a6b86a.mp3";